/**
 * 基础页：首页 / 登录 / 商家入驻
 * 由原 src/router.js 原样搬移（顺序即路由匹配优先级，请勿调整）；
 * 仅把动态导入路径 './views/xxx.vue' 改为 '@/views/xxx.vue'（@ = src）。
 */
export default [
  {
    path: '/',
    name: 'home',
    // redirect: '/mall',
    component: () =>
      import(
        /* webpackChunkName: "common" */
        '@/views/home/index.vue'
      ),
    meta: {
      title: '熊猫优福'
    }
  },
  {
    path: '/home',
    // 原来与 '/' 同名 home，Vue Router 要求 name 全局唯一，后者会被遮蔽
    name: 'homeAlias',
    // redirect: '/mall',
    component: () =>
      import(
        /* webpackChunkName: "common" */
        '@/views/home/index.vue'
      ),
    meta: {
      title: '熊猫优福',
      isCommon: true
    }
  },
  {
    // 假的 应付检查
    path: '/business_settlement',
    name: 'business_settlement',
    // redirect: '/mall',
    component: () =>
      import(
        /* webpackChunkName: "common" */
        '@/views/businessSettlement/index.vue'
      ),
    meta: {
      title: '商家入驻',
      isCommon: true
    }
  },
  {
    path: '/login',
    name: 'login',
    component: () =>
      import(
        /* webpackChunkName: "common" */
        '@/views/login/index.vue'
      ),
    meta: {
      title: '登录',
      hideHeader: true
    }
  }
];
